import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=2087befe&scoped=true"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=2087befe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087befe",
  null
  
)

export default component.exports